import { PaginationProps } from 'antd'
import * as S from './styles'

export type BasePaginationProps = PaginationProps

export const BasePagination: React.FC<BasePaginationProps> = props => {
  return <S.Pagination {...props} />
}
